module.exports = __webpack_public_path__ + "img/banner-pic.c4deaab2.png";